module.exports = __webpack_public_path__ + "img/CellCycle-OSCC_GSE208253.3f2cb4fc.png";